import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import customer from '../../customer';
const {hasMultipleSubscriptions, getFullName, getActiveSubscriptionName} = customer.selectors;

const NavUserInfo = ({
  useCollapsedStyle,
  fullName,
  multiSubscriptions,
  onClick,
  subscriptionName
}) => {
  let navMenuClass = `toggle-btn align-middle ${useCollapsedStyle ? 'collapsed' : ''}`;

  return (
    <div>
      <div id="navMenu" className={navMenuClass} onClick={onClick}>
        <div className="name text-right">
          <div className="name-wrap" >{fullName}</div>
        </div>
        {multiSubscriptions && <div className="store">{subscriptionName}</div>}
      </div>
      <div className="user">{fullName}</div>
      {multiSubscriptions && <div className="store-sidenav">{subscriptionName}</div>}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    fullName: getFullName(state),
    multiSubscriptions: hasMultipleSubscriptions(state),
    subscriptionName: getActiveSubscriptionName(state)
  };
}

NavUserInfo.propTypes = {
  fullName: PropTypes.string.isRequired,
  multiSubscriptions: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  subscriptionName: PropTypes.string.isRequired,
  useCollapsedStyle: PropTypes.bool.isRequired
};

export default connect(mapStateToProps)(NavUserInfo);


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/components/NavUserInfo.js
 **/